import { apiClient, adminApiClient } from './config'

export const authService = {
  async register(data) {
    return apiClient.post('/auth/register', data)
  },

  async login(email, password, rememberMe = true) {
    return apiClient.post('/auth/login', { email, password, rememberMe })
  },

  async sendCode(email, { captchaToken, website } = {}) {
    return apiClient.post('/auth/send-code', { email, captchaToken, website })
  },

  async verifyCode(email, code, rememberMe = true) {
    return apiClient.post('/auth/verify-code', { email, code, rememberMe })
  },

  async resendCode(email, { captchaToken, website } = {}) {
    return apiClient.post('/auth/resend-code', { email, captchaToken, website })
  },

  async refresh() {
    return apiClient.post('/auth/refresh')
  },

  async logout() {
    try {
      await apiClient.post('/auth/logout')
    } catch {
      // ignore network errors on logout
    }
  },

  async getCurrentUser() {
    return apiClient.get('/auth/me')
  },

  async forgotPassword(email) {
    return apiClient.post('/auth/forgot-password', { email })
  },

  async resetPassword(email, token, password) {
    return apiClient.post('/auth/reset-password', { email, token, password })
  },
}

export const adminAuthService = {
  async login(email, password, rememberMe = true) {
    return adminApiClient.post('/admin/auth/login', { email, password, rememberMe })
  },

  async logout() {
    try {
      await adminApiClient.post('/admin/auth/logout')
    } catch {
      // ignore network errors on logout
    }
  },

  async getCurrentAdmin() {
    return adminApiClient.get('/admin/auth/me')
  },
}
